import { DriverRankTierConfigsService } from '@/backend/market'
import type { CreateUpdateDriverRankTierConfigEntity } from '../../domain/entities/CreateUpdateDriverRankTierConfigEntity'
import type { DriverRankTierConfigEntity } from '../../domain/entities/DriverRankTierConfigEntity'
import { DriverRankTierConfigRepository } from '../../domain/repositories/DriverRankTierConfigRepository'
import { CreateUpdateDriverRankTierConfigModel } from '../models/CreateUpdateDriverRankTierConfigModel'
import { DriverRankTierConfigModel } from '../models/DriverRankTierConfigModel'

export class DriverRankTierConfigRepositoryImpl implements DriverRankTierConfigRepository {
  async getDriverRankTierConfigs(
    regionId?: number
  ): Promise<DriverRankTierConfigEntity[] | { error: true }> {
    try {
      const response = await DriverRankTierConfigsService.getDriverRankTierConfigsAdmin({ regionId })
      return response.map((item) => new DriverRankTierConfigModel(item))
    } catch {
      return { error: true }
    }
  }

  async createDriverRankTierConfig(
    data: CreateUpdateDriverRankTierConfigEntity
  ): Promise<DriverRankTierConfigEntity | { error: true }> {
    const requestBody = new CreateUpdateDriverRankTierConfigModel(data)

    try {
      const response = await DriverRankTierConfigsService.postDriverRankTierConfigAdmin({
        requestBody
      })
      return new DriverRankTierConfigModel(response)
    } catch {
      return { error: true }
    }
  }

  async updateDriverRankTierConfig(
    id: string,
    data: CreateUpdateDriverRankTierConfigEntity
  ): Promise<DriverRankTierConfigEntity | { error: true }> {
    const requestBody = new CreateUpdateDriverRankTierConfigModel(data)

    try {
      const response = await DriverRankTierConfigsService.putDriverRankTierConfigAdmin({
        id,
        requestBody
      })
      return new DriverRankTierConfigModel(response)
    } catch {
      return { error: true }
    }
  }
}
